import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ReturnResult } from '../models/return-result';

export interface ShareViewModel {
  itemId: string;
  itemType: string;
  sharedWithUserId: string;
  sharedWithRoleId: string;
  isPublic: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ShareService {
  // Using a general API endpoint since apiShare is not defined in environment
  private baseUrl = environment.apiShareData;

  constructor(private http: HttpClient) { }

  shareItem(model: ShareViewModel): Observable<ReturnResult<boolean>> {
    return this.http.post<ReturnResult<boolean>>(`${this.baseUrl}/ShareItem`, model);
  }

  getShareInfo(itemId: string, itemType: string): Observable<ReturnResult<ShareViewModel>> {
    return this.http.get<ReturnResult<ShareViewModel>>(`${this.baseUrl}/GetShareItem`, {
      params: {
        itemId,
        itemType
      }
    });
  }
}
